export const parseFilenameFromContentDisposition = (header: string | null): string | null => {
    if (!header) return null;
    const utf8 = header.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (utf8) {
        try {
            return decodeURIComponent(utf8[1]);
        } catch {
            /* fall through */
        }
    }
    const quoted = header.match(/filename\s*=\s*"([^"]+)"/i) || header.match(/filename\s*=\s*([^;]+)/i);
    return quoted ? quoted[1].trim() : null;
};

export const downloadFromUrl = async (url: string, fallbackFileName: string) => {
    const res = await fetch(url);
    if (!res.ok) throw new Error('Fetch failed');
    const blob = await res.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = parseFilenameFromContentDisposition(res.headers.get('Content-Disposition')) || fallbackFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
};
